// extracted by mini-css-extract-plugin
module.exports = {"textarea":"-QplI6W0h2yDiI6d0pqDe"};